import React, {Fragment} from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import Seo from "./seo";

const Layout = ({ children, title, description, location, darkMode, toggleTheme, className }) => {
    return (
        <Fragment>
            <Header location={location} title={title} darkMode={darkMode} toggleTheme={toggleTheme} />
            <Seo title={title} description={description} />
            <main className={className}>{children}</main>
            <Footer darkMode={darkMode} />
        </Fragment>
    );
};

export default Layout;
